import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {ReportOPEEnum} from "./ReportOPEEnum";
import {AggregateFunctionTypeEnum, BucketUnitEnum} from "../../enums/dashboard/ChartsEnum";

class MetricInputDTO {
  id!: number;
  functionType!: AggregateFunctionTypeEnum;
}

class O {
  id!: number;
}

class I {
  id?: number;
  name!: string;
  unixCronExpression!: string;
  enabled: boolean = true;
  bucketUnits!: BucketUnitEnum;
  bucketValue!: number;
  email!: string;
  metrics: MetricInputDTO[] = [];
}

export class PutUserReportCB extends BaseSpringServiceCB {
  public i: I;
  public o: O;

  constructor() {
    super(ReportOPEEnum.PutUserReport);
    this.i = new I();
    this.o = new O();
  }
}
